<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="introduction">
<h1>Introduction</h1>
<p>During the course of a long life, Martin Kyrle has done a fair bit of travelling, mostly for pleasure. Apart from crossing Mongolia after several weeks on the Trans-Siberian Railway (see inside front cover), few of the places he’s visited may be classed as exotic, but catching ferries to islands off the coasts of France, Holland or Estonia or in his twenties hitch-hiking the length of Norway and coming home through Lapland has taken him to locations few people will be familiar with.</p>
<p>This collection of anecdotes runs alphabetically not chronologically and can be read in any order. Each letter begins with a map, an arrow and a flag offering a clue to where you’re being taken. Next day, speculate where you’re off to tonight. It may be with his wife fifteen years ago or with a student friend back in the 1950s long before mobile phones existed and when at every frontier passports were stamped and a different currency was needed.</p>
<p>The stories are designed to be read last thing at night, and the postscripts (for which, perhaps, read ‘silly jokes’ – but some of them entirely original!) are added just for fun to help the reader go to sleep with a smile on his or her face.</p>
<p>Although offered as entertainment, at times some serious analysis is woven into the narrative or an observation is made which is redolent of the times. Something, perhaps, to ponder next day while anticipating the itinerary of tonight’s letter.</p>
<p style="text-align: center; padding-top:15px; padding-bottom:15px;"><img alt="" src="media/file0.png" style="width:4.63023in;height:7.69762in"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?cce0e800